import React from 'react';
import uuid from 'uuid/v4';
import PropTypes from 'prop-types';
import GenericBasicTableView from '../../common/GenericBasicTable/GenericBasicTableView';
import { CAC_CLUSTER_SEGMENT_TABLE_ROW_HEADERS } from '../CacConstants';
import SegmentNotableCard from './SegmentNotableCard';

const ClusterSegmentSummary = props => {
  const { segmentData } = props;
  const headerList = [];
  let tableData;

  if (segmentData !== undefined) {
    segmentData.forEach((item, index) => {
      headerList.push({
        key: index,
        label: item.segmentName,
        text: item.segmentName,
      });
    });
    tableData = {
      rowHeader: CAC_CLUSTER_SEGMENT_TABLE_ROW_HEADERS,
      rowData: [
        {
          values: segmentData.map(item => item.sample),
        },
        {
          values: segmentData.map(item => `${Math.round(item.pct)}%`),
        }],
    };
  }
  if(tableData) {
    return (
      <div className="segment-summary-block">
        <p className="segment-summary-title">
          Segment Summary
        </p>
        <GenericBasicTableView
          tableData={tableData}
          tableHeader={headerList}
          isSegmentSummaryTable
        />
        <div className="segment-notable-card-group">
        {segmentData && segmentData.map((item, index) => (
          <SegmentNotableCard
            key={uuid()}
            segmentCardData={item}
            index={index}
          />
        ))}
      </div>
	  
      </div>
    );
  }
  return null;
};

ClusterSegmentSummary.propTypes = {
  segmentData: PropTypes.arrayOf(PropTypes.object),
};

export default ClusterSegmentSummary;
